import $ from 'jquery';
import {
  metaTagString,
  getTitle,
  getDescription,
  getImage,
} from '../../utilities/meta_tags_util';
import { checkImgType } from '../../utilities/image_util';

export default (urlPath, language, query, params) => {
  let metaData = '';

  metaData += metaTagString({
    urlPath,
    title: '景點名稱',
    description: '景點地址',
    language,
    noindex: false,
  });

  return {
    metaData,
  };
};

// search 討論後不給 meta-data 改在 client 自己 Handle
// 景點頁目前僅出自 PoiBank 而非使用者，暫不用擔心 xss
export const clientHandleMeta = ({ name, description, photos, language }) => {
  $('meta[name=description]').remove();
  $('meta[itemprop="description"]').remove();
  $('meta[property="og:description"]').remove();
  $('meta[property="og:title"]').remove();
  $('meta[property="og:image"]').remove();
  $('meta[itemprop="image"]').remove();

  const img = photos.length
    ? checkImgType({ data: photos[0], isSSR: true, widthLimit: 700 })
    : getImage(language);

  const descriptionText = description || getDescription(language);
  const titleText = `${name} | ${getTitle(language)}`;
  document.title = titleText;

  $('head')
    .append(`<meta name="description" content="${descriptionText}">`)
    .append(`<meta itemprop="description" content="${descriptionText}">`)
    .append(`<meta property="og:description" content="${descriptionText}">`)
    .append(`<meta property="og:title" content="${titleText}">`)
    .append(`<meta property="og:image" content="${img}">`)
    .append(`<meta itemprop="image" content="${img}">`);
};
